import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M23.6 11.239c-7.415-7.466-5.061-5.149-9.1-9.223a3.583 3.583 0 0 0-5 0L.4 11.239a1.409 1.409 0 0 0 0 1.972 1.362 1.362 0 0 0 1.946 0l9.094-9.22a.8.8 0 0 1 1.113 0l9.1 9.221a1.364 1.364 0 0 0 1.946 0 1.409 1.409 0 0 0 .001-1.973Z" }),
      _createElementVNode("path", { d: "M12.477 5.398a.663.663 0 0 0-.95 0L3.57 13.506a.693.693 0 0 0-.2.485v5.914a2.49 2.49 0 0 0 2.465 2.513h3.94v-6.219h4.45v6.219h3.94a2.49 2.49 0 0 0 2.465-2.513v-5.914a.691.691 0 0 0-.2-.485Z" })
    ], -1)
  ])))
}
export default { render: render }